import { render, staticRenderFns } from "./CardSplit.vue?vue&type=template&id=246e2832"
import script from "./CardSplit.vue?vue&type=script&lang=js"
export * from "./CardSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports